import { Box, Text } from '@quintoandar-tokko/jopijs';
import ImageNext from '@/components/shared/ImageNext';
import styles from './DashboardEmptyStateCard.module.scss';

function DashboardEmptyStateCard({
  icon,
  title,
  description,
  buttonText,
  onButtonClick,
}) {
  return (
    <Box className={styles.emptyStateCard}>
      <Box className={styles.emptyStateIconWrapper}>
        <ImageNext
          alt={title}
          src={icon}
          width={88}
          height={88}
          className={styles.emptyStateIcon}
        />
      </Box>
      <Box as="h3" className={styles.emptyStateTitle}>
        {title}
      </Box>
      <Text className={styles.emptyStateDescription}>{description}</Text>

      {buttonText && (
        <Box
          as="button"
          className={styles.emptyStateButton}
          onClick={onButtonClick}
        >
          {buttonText}
        </Box>
      )}
    </Box>
  );
}

export default DashboardEmptyStateCard;
